import React from 'react';

const VisaInfo = () => {
  return (
    <div>
      <div>
        
        <div className='privacy-policy-container'>
        <div className='privacy-policy-subtitle'>Visa Info</div>
          <div className='privacy-policy-list'>
          <ul>
            <li>Race against the best on the virtual reality experience. Take your place in the spotlight.</li>
            <li>Race against the best on the virtual reality experience. Take your place in the spotlight.</li>
          </ul>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <button style={{ backgroundColor: '#541C9C', borderRadius: '30px',color:'white' }}>Check Status/Apply for Visa</button>
        <button style={{ position: 'absolute', backgroundColor: '#541C9C', borderRadius: '30px', marginTop: '100px',color:'white' }}>Place Holder</button>
      </div>
    </div>
  );
};

export default VisaInfo;
